import { TableRowColors } from '@/common/constants';

export const rowBackgroundColorClassMap = {
  [TableRowColors.GREEN]: 'bg-pmw-teams-table-green',
  [TableRowColors.DARK_GREEN]: 'bg-pmw-teams-table-darkgreen',
  [TableRowColors.YELLOW]: 'bg-pmw-teams-table-yellow',
  [TableRowColors.LIGHT_BLUE]: 'bg-pmw-teams-table-lightblue',
  [TableRowColors.DARK_BLUE]: 'bg-pmw-teams-table-darkblue',
  [TableRowColors.TEAL]: 'bg-pmw-teams-table-teal',
  [TableRowColors.ORANGE]: 'bg-pmw-teams-table-orange',
  [TableRowColors.RED]: 'bg-pmw-teams-table-red',
};
